export const authConfig = {
  google: {
    clientId: '820327382797-tn9ot4ud5mdobboukjo610e34379drl4.apps.googleusercontent.com',
  },
  
  microsoft: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || 'd7d6a9c6-d51a-49e1-bc34-7d3572b38bfb',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: `${window.location.origin}/microsoft-login`,
    scopes: ["User.Read", "profile", "openid", "email"],
  },
  
  myLogin: {
    clientId: process.env.REACT_APP_MYLOGIN_CLIENT_ID || '26f95eac-13f0-4e4f-9f95-ed510da388fe',
    url: process.env.REACT_APP_MYLOGIN_URL || 'https://app.mylogin.com',
    redirectUri: process.env.REACT_APP_MYLOGIN_REDIRECT_URI || `${window.location.origin}/mylogin/callback`,
    scope: 'openid profile email',
    responseType: 'code',
    secretKey: '915494e067cc8f60eb19dce1d390627e1716fa04b72bdc0c7da8b6c68eff501132fdb45aec2b9b34aa27c716307f86a1ce2fa33269e35d6bcf609da3d771cbf229390016f732',
  },
  
  skipRedirectStorage: [
    '/login',
    '/login-redirect',
    '/',
    '/email-login',
    '/token-verification',
    '/google-login',
    '/microsoft-login',
    '/mylogin/callback',
    '/e',
  ]
};